<script setup lang="ts">
import BaseIcon from '~/components/foundations/BaseIcon.vue'

defineEmits<{
  (e: 'back'): void
}>()
</script>

<template>
  <header class="simple-header">
    <nav class="navigation">
      <div>
        <button class="navbar-item" type="button" aria-label="戻る" @click="$emit('back')">
          <BaseIcon type="arrowBack" />
        </button>
      </div>

      <div>
        <slot name="right" />
      </div>
    </nav>
  </header>
</template>

<style scoped lang="scss">
.simple-header {
  box-shadow: 0 2px 0 0 hsl(0, 0%, 96%);
  padding: 0.5rem;

  .navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3rem;
    .navbar-item {
      background: none;
      border: none;
      cursor: pointer;
      &:hover {
        background-color: var(--semantic-tokens-neutral-xweak-surface);
      }
    }
  }
}
</style>
